import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Announcement from "./sections/Announcement";
import Hero from "./sections/Hero";
import ClinicalHero from "./sections/ClinicalHero";
import Philosophy from "./sections/Philosophy";
import Institutions from "./sections/Institutions";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
import Order from "./sections/Order";
export default function HomePage() {
  return <div>
      <Navigation />
      <Hero />
      <Announcement />
      <Philosophy />
      <Testimonials />
      <Order />
      <Footer />
    </div>;
}